import { User } from 'panel/user/redux/types'
import { Category } from 'panel/category/redux/types'
import { AlertActionTypes } from 'util/modules/Alert/redux/types'
/**
* Data Types
*/

import { PartnerStaff } from '../staff/redux/types'
import { PaginationOpts } from 'util/types/index'

export interface Partner {
  id: number,
  order: number,
  pictureTiny: string,
  pictureSmall: string,
  pictureMedium: string,
  isActive: boolean,
  name: string,
  description: string,
  deliveryType: string,
  productionMin: number,
  productionMinTime: number,
  productionMaxTime: number,
  distribution: string[],
  average: number,
  balance: number,
  products: number,
  sales: number,
  views: number,
  zip: string,
  state: string,
  city: string,
  street: string,
  number: string,
  district: string,
  complement: string,
  latitude: number,
  longitude: number,
  category: Partial<Category>,
  manager: Partial<User> & { person: { id: number, firstName: string, lastName: string, name: string } },
  staffs?: PartnerStaff[],
  createdAt: string,
  updatedAt?: string
}

/**
* State Type
*/

export interface PartnerState {
  readonly partner?: Partner
  readonly partnerList: { items: Partner[], pagination?: PaginationOpts }
}

/**
* Action Enum Types
*/

export enum PartnerTypes {
  PARTNER_CREATE = 'PARTNER/CREATE',
  PARTNER_UPDATE = 'PARTNER/UPDATE',
  PARTNER_DELETE = 'PARTNER/DELETE',
  PARTNER_GET = 'PARTNER/GET',
  PARTNER_LIST = 'PARTNER/LIST'
}

/**
* Action Types
*/
interface CreatePartner {
  type: typeof PartnerTypes.PARTNER_CREATE,
  payload: Partner
}

interface UpdatePartner {
  type: typeof PartnerTypes.PARTNER_UPDATE,
  payload: Partner
}

interface DeletePartner {
  type: typeof PartnerTypes.PARTNER_DELETE,
  payload: number
}

interface GetPartner {
  type: typeof PartnerTypes.PARTNER_GET,
  payload: Partner
}

interface GetPartnerList {
  type: typeof PartnerTypes.PARTNER_LIST,
  payload: Partner[]
  pagination?: PaginationOpts
}

export type PartnerActionTypes = (
  AlertActionTypes | CreatePartner | UpdatePartner | DeletePartner | GetPartner | GetPartnerList
)
